import script from "./ReportButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportButton.vue?vue&type=script&setup=true&lang=ts"

import "./ReportButton.vue?vue&type=style&index=0&id=4ed15b94&lang=css"

const __exports__ = script;

export default __exports__